import React from 'react';
import PropTypes from 'prop-types';
import formatCurrency from 'format-currency';
import { connect } from 'react-redux';

import '../../static/less/loyalty.less';
//import { setShowClaimPopup } from '../../actions/Loyalty';
import { setShowLogin } from '../../actions/Loyalty';
import { convertCoinsToCurrency, getMaxCoinsToApply, showLoyaltyRedeem } from '../../utils';
import { store } from '../../Store';
import { DEVICES } from '../../actions/Booking';
import { CALL_CENTER_ROLE } from '../../constants';

class LoyaltyUserRate extends React.Component {
  getAmount() {
    const { amount } = this.props.board.amount[this.props.currency.code];
    let amountToShow = 0;
    if (this.props.new_member_discount_percentage_activated === true && this.props.new_member === true) {
      const totalTaxes = amount * (this.props.hotel.percentage_total_taxes / 100);
      // REVERT SI SE NECESITA CALCULAR MEMBER RATE Y SA NET RATE TOMANDO EN CUENTA EL COSTO DE LA RESERVA
      // SIN IMPUESTOS. AHROTIA LO TUVIMOS QUE DEJAR COMO ANTES, CALCULANDO EL MEMBER RATE Y SA NET RATE TOMANDO
      // EL COSTO TOTAL DE LA RESERVA CON IMPUESTOS
      // Si se necesita después que el member rate se calcule con base en el costo
      // de la reserva sin impuestos, descomentar esa parte y usarla en lugar de la que la que se está usando abajo
      /*
      const totalTaxes = amount * (this.props.hotel.percentage_total_taxes / 100);
      const totalAmountWithoutTaxesIncluded = amount - totalTaxes;
      amountToShow = amount - (totalAmountWithoutTaxesIncluded * (this.props.new_member_discount_percentage / 100))
      - convertCoinsToCurrency(getMaxCoinsToApply(amount, true));
      */
      amountToShow = amount - (amount * (this.props.new_member_discount_percentage / 100))
      - convertCoinsToCurrency(getMaxCoinsToApply(amount, true));
      if (amountToShow < 0) {
        amountToShow = 0;
      }
      // Para mostrar tarifas sin impuestos
      if (this.props.hotel != null) {
        if (this.props.hotel.percentage_total_taxes > 0 && window.location.pathname !== '/all-rooms/') {
          // REVERT SI SE NECESITA CALCULAR MEMBER RATE Y SA NET RATE TOMANDO EN CUENTA EL COSTO DE LA RESERVA
          // SIN IMPUESTOS. AHROTIA LO TUVIMOS QUE DEJAR COMO ANTES, CALCULANDO EL MEMBER RATE Y SA NET RATE TOMANDO
          // EL COSTO TOTAL DE LA RESERVA CON IMPUESTOS
          // Si se necesita después que el member rate se calcule con base en el costo
          // de la reserva sin impuestos, descomentar esa parte y usarla en lugar de la que la que se está usando abajo
          /*
          amountToShow -= totalTaxes;
          */
          amountToShow -= totalTaxes;
        }
      }
      return amountToShow;
    }
    amountToShow = amount - convertCoinsToCurrency(getMaxCoinsToApply(amount, true));
    // Para mostrar tarifas sin impuestos
    if (this.props.hotel != null) {
      if (this.props.hotel.percentage_total_taxes > 0) {
        amountToShow -= (amountToShow * (this.props.hotel.percentage_total_taxes / 100));
      }
    }
    return amountToShow;
  }

  getMessage() {
    return this.context.t('{brand} RATE', { brand: this.props.loyaltyName });
  }

  render() {
    const newCurrency = { ...this.props.currency, minimumFractionDigits: 0, maximumFractionDigits: 0 };
    if (this.props.memberInfo.accountHolder != null || this.props.selectedStatus === 'becomeMember') {
      // Determine the class name based on props.brandName
      let className = 'loyaltyUserRateBlue';
      if (this.props.memberInfo.accountHolder == null) {
        className = 'loyaltyUserRateBlue';
      } else if (this.props.memberInfo.membershipName.toLowerCase().includes('blue')) {
        className = 'loyaltyUserRateBlue';
      } else if (this.props.memberInfo.membershipName.toLowerCase().includes('gold')) {
        className = 'loyaltyUserRateGold';
      } else if (this.props.memberInfo.membershipName.toLowerCase().includes('silver')) {
        className = 'loyaltyUserRateSilver';
      } else if (this.props.memberInfo.membershipName.toLowerCase().includes('platinum')) {
        className = 'loyaltyUserRateSilver';
      } else if (this.props.memberInfo.membershipName.toLowerCase().includes('black')) {
        className = 'loyaltyUserRateBlack';
      } else {
        className = 'loyaltyUserRateBlue'; // Default or empty class if needed
      }

      return (
              <div className={`${className} card-content`}>
                {this.props.showJustTotalQuantity === false
                && <div className={this.props.isMobile ? 'width60PorCientoLeft' : 'width40PorCientoLeft'}>
                  <span className={this.props.isMobile ? 'loyaltyUserRateMessageMobile' : 'loyaltyUserRateMessage'}>
                    {this.context.t('{brand} RATE', {
                      brand: (this.props.agentCode !== '' && this.props.agentSell === 'false')
                        ? 'Sandos Advisors' : this.props.loyaltyName.toUpperCase(),
                      loyaltyLevel: this.props.memberInfo.membershipName
                        ? this.props.memberInfo.membershipName.toUpperCase()
                        : this.props.agentCode !== '' ? 'Blue Agent' : 'Blue',
                    })}
                  </span>
                  {/*<i className={'fa fa-info'} onClick={() => this.props.dispatch(setShowClaimPopup(true))}/>*/}
                </div>}
                {this.props.showJustTotalQuantity === false && this.props.isCallCenterUser === false
                && <div
                  className={this.props.isMobile ? 'width40PorCientoRight paddingRight03rem' : 'width30PorCientoRight'}
                >
                  <strong className="amountsForceShowCorrectlyAlligned">
                    {formatCurrency(this.getAmount() / this.props.lastRequestedInfo.nights, newCurrency)}</strong>
                  {/*<small>{this.context.t('Per night')}</small>*/}
                </div>
                }
                {(this.props.isMobile === false || this.props.showJustTotalQuantity === true)
                && <div className={this.props.isMobile
                  ? 'width100PorCientoRight' : this.props.isCallCenterUser === false
                    ? 'width30PorCientoRight' : 'width30PorCientoLeft'}>
                  <strong className="amountsForceShowCorrectlyAlligned">
                    {formatCurrency(this.getAmount(), newCurrency)}</strong>
                  {/*<small>{this.context.t('Total price')}</small>*/}
                </div>
                }
              </div>
      );
    }
    const state = store.getState();
    let { agentCode, agentSell } = state.booking;
    if (agentCode == null) {
      agentCode = '';
    }
    if (agentSell == null) {
      agentSell = '';
    }
    //if (showLoyaltyRedeem() && (agentCode === '' || (agentCode !== '' && agentSell === 'true'))) {
    //con eso el agente podría pedir que el cliente (en caso de vender a otros clientes con agentSell=true) se logeara
    //en loyalty. Al final se hará algo parecido como con call center. El agente sólo deberá poner el correo del cliente
    if (showLoyaltyRedeem() && agentCode === '' && this.props.showJoinLoyaltyMessage === true) { //Cambios relacionados a agent code
      // Con esto controlamos si queremos que se muestre la opción para logearse en el confirmationForm
      //Si no es un agente se muestra la opción para logearse
      //O si es un agente y va a vender a otros clientes
      //CONTROL DE LOGIN EN LOYALTY
      return (
              <button className='btn add-stays border border-primary text-center text-primary bold-text p-1 loyalty-btn'
                      onClick={() => this.props.dispatch(setShowLogin(true))}>
                {this.context.t('Join at {brand} and Start Saving Now', { brand: this.props.loyaltyName })}
              </button>
      );
    }
    return null;
  }
}

LoyaltyUserRate.propTypes = {
  board: PropTypes.object.isRequired,
  forceAmount: PropTypes.number,
  showJoinLoyaltyMessage: PropTypes.bool,
  showJustTotalQuantity: PropTypes.bool,
};

LoyaltyUserRate.contextTypes = {
  t: PropTypes.func.isRequired,
};

LoyaltyUserRate.defaultProps = {
  showJoinLoyaltyMessage: true,
  showJustTotalQuantity: false,
};

const mapStateToProps = (state) => ({
  loyaltyName: state.session.chainData.booking_engine_configuration.loyalty_name,
  currency: state.booking.filterCurrency,
  loggedUser: state.loyalty.loggedUser,
  memberInfo: state.loyalty.memberInfo,
  chainData: state.session.chainData,
  hotel: state.booking.hotel,
  register_now_discount: state.loyalty.coinsForRegistering,
  new_member: state.loyalty.newMember,
  new_member_discount_percentage: state.loyalty.newMemberDiscountPercentage,
  new_member_discount_percentage_activated: state.booking.hotel != null
    ? (state.booking.hotel.new_member_discount_percentage_activated === true
      && state.bookingFormState.agentSell === 'false') : false,
  lastRequestedInfo: state.booking.last_requested_info,
  isMobile: state.booking.device === DEVICES.MOBILE,
  isTabletV: state.booking.device === DEVICES.TABLETV,
  isTabletH: state.booking.device === DEVICES.TABLETH,
  isDesktop: state.booking.device === DEVICES.DESKTOP,
  isCallCenterUser: state.session.user.role === CALL_CENTER_ROLE,
  selectedStatus: state.loyalty.selectedStatus,
  agentCode: state.bookingFormState.agentCode,
  agentSell: state.bookingFormState.agentSell,
});

export default connect(mapStateToProps)(LoyaltyUserRate);
